import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import { categories } from '@/mocks/categories';
import { getPopularComics, getLatestComics } from '@/mocks/comics';

export default function Home() {
  const popularComics = getPopularComics(8);
  const latestComics = getLatestComics(8);

  return (
    <>
      <SEOHead
        title="韩国漫画无删减漫画下拉式-免费韩漫在线阅读-韩漫网址"
        description="想找无删减韩国漫画？下拉式阅读体验+免费韩漫在线阅读尽在韩漫网址，海量优质韩漫资源覆盖多样题材，无需付费即可畅快浏览。恋爱、奇幻、动作、悬疑、喜剧、剧情等热门分类一网打尽。"
        keywords="韩国漫画,无删减漫画,下拉式漫画,免费韩漫,韩漫在线阅读,韩漫网址"
        canonicalUrl="https://hanman.example.com/"
      />
      <SchemaOrg type="WebSite" data={{
        name: '韩漫网址',
        url: 'https://hanman.example.com/',
        description: '韩国漫画无删减下拉式阅读平台，免费韩漫在线阅读',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://hanman.example.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }} />
      <SchemaOrg type="Organization" data={{
        name: '韩漫网址',
        url: 'https://hanman.example.com/',
        description: '韩国漫画无删减下拉式阅读平台',
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <section className="relative w-full h-[480px] md:h-[620px] flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20cozy%20reading%20nook%20with%20open%20books%20and%20soft%20golden%20lighting%2C%20ink%20wash%20painting%20style%20with%20modern%20Korean%20aesthetic%2C%20warm%20cream%20and%20terracotta%20tones%2C%20abstract%20and%20atmospheric%20composition%20with%20floating%20illustration%20elements%2C%20dreamy%20and%20inviting%20mood&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
              alt="韩漫网址 - 韩国漫画在线阅读平台"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
            <div className="relative z-10 w-full px-4 md:px-6 text-center">
              <div className="max-w-3xl mx-auto">
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight">
                  韩国漫画 · 无删减<span className="text-accent-400">下拉式</span>阅读
                </h1>
                <p className="mt-4 md:mt-6 text-base md:text-lg text-background-200/90 max-w-2xl mx-auto leading-relaxed">
                  海量优质韩国漫画资源，覆盖恋爱、奇幻、动作、悬疑、喜剧、剧情等多样题材。
                  免费韩漫在线阅读，无需付费即可畅快浏览。
                </p>
                <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to="/category/all"
                    className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    开始阅读
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                  <Link
                    to="/about"
                    className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 backdrop-blur-sm rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
                  >
                    了解更多
                  </Link>
                </div>
                <div className="mt-8 flex items-center justify-center gap-6 text-background-200/70 text-sm">
                  <div className="flex items-center gap-1.5">
                    <i className="ri-book-read-line"></i>
                    <span>18+ 部精选韩漫</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <i className="ri-user-heart-line"></i>
                    <span>全部免费阅读</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <i className="ri-smartphone-line"></i>
                    <span>下拉式流畅体验</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                  探索分类
                </h2>
                <p className="mt-2 text-sm text-foreground-600">
                  多种题材任你选择，找到你最喜欢的韩国漫画类型
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3">
                {categories.filter(c => c.slug !== 'all').map(cat => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors duration-300">
                      <i className={`${cat.icon} text-xl`}></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap font-heading">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                    热门推荐
                  </h2>
                  <p className="mt-2 text-sm text-foreground-600">
                    最受读者欢迎的韩国漫画精选
                  </p>
                </div>
                <Link
                  to="/category/all"
                  className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看全部
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {popularComics.map(comic => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
              <div className="mt-6 text-center sm:hidden">
                <Link
                  to="/category/all"
                  className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap cursor-pointer"
                >
                  查看全部漫画
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                    最新更新
                  </h2>
                  <p className="mt-2 text-sm text-foreground-600">
                    实时追踪最新上线的韩国漫画章节
                  </p>
                </div>
                <Link
                  to="/category/all"
                  className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看全部
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {latestComics.map(comic => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                  为什么选择韩漫网址？
                </h2>
                <p className="mt-2 text-sm text-foreground-600">
                  我们致力于为中文读者提供最优质的韩国漫画阅读体验
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {[
                  { icon: 'ri-shield-check-line', title: '无删减内容', desc: '完整呈现原作内容，拒绝删减与修改，还原最纯粹的韩漫阅读体验。' },
                  { icon: 'ri-scroll-to-bottom-line', title: '下拉式阅读', desc: '流畅的下拉式阅读方式，无需翻页，一气呵成享受漫画的每一格画面。' },
                  { icon: 'ri-money-cny-circle-line', title: '完全免费', desc: '全部韩国漫画资源免费提供，无需付费订阅，随时随地畅享韩漫世界。' },
                  { icon: 'ri-stack-line', title: '海量资源', desc: '持续更新丰富的韩国漫画资源库，覆盖恋爱、奇幻、动作等多元题材。' },
                ].map((item, i) => (
                  <div key={i} className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                    <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">{item.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                  常见问题
                </h2>
                <p className="mt-2 text-sm text-foreground-600">
                  关于韩漫网址的常见疑问解答
                </p>
              </div>
              <div className="space-y-3">
                {[
                  {
                    q: '韩漫网址上的漫画真的是免费的吗？',
                    a: '是的，韩漫网址上所有韩国漫画资源均免费提供在线阅读，无需任何付费即可畅快浏览全部内容。我们致力于为中文读者提供优质的免费韩漫阅读服务。',
                  },
                  {
                    q: '什么是下拉式阅读体验？',
                    a: '下拉式阅读是韩国漫画特有的阅读方式，您只需向下滑动页面即可连续阅读，无需点击翻页。这种流畅的阅读方式让您沉浸在漫画世界中，享受一气呵成的阅读乐趣。',
                  },
                  {
                    q: '韩漫网址上的内容是否无删减？',
                    a: '我们坚持提供无删减的韩国漫画内容，完整呈现原作的所有画面和情节，确保读者能够欣赏到原汁原味的韩漫作品。',
                  },
                  {
                    q: '网站支持哪些题材的韩国漫画？',
                    a: '我们目前涵盖恋爱、奇幻、动作、悬疑、喜剧、剧情六大热门题材，并且持续扩充新的分类和漫画资源，满足不同读者的喜好。',
                  },
                ].map((faq, i) => (
                  <details key={i} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
                    <summary className="flex items-center justify-between p-5 cursor-pointer font-medium text-foreground-900 text-sm list-none">
                      {faq.q}
                      <i className="ri-arrow-down-s-line text-lg text-foreground-400 group-open:rotate-180 transition-transform duration-300"></i>
                    </summary>
                    <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 px-4 md:px-6 bg-accent-50">
            <div className="max-w-xl mx-auto text-center">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-5">
                <i className="ri-mail-send-line text-2xl"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                订阅更新通知
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                第一时间获取最新韩国漫画上架通知和热门推荐
              </p>
              <form
                data-readdy-form
                className="mt-6 flex flex-col sm:flex-row gap-3"
                action="https://readdy.ai/api/form/d9pc6gosenbniolessl0"
                method="POST"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const honeypot = formData.get('phone_alt') as string;
                  if (honeypot && honeypot.trim() !== '') {
                    const msg = document.getElementById('newsletter-msg');
                    if (msg) { msg.textContent = '订阅成功！感谢您的关注。'; msg.className = 'mt-3 text-sm text-green-600'; }
                    form.reset();
                    return;
                  }
                  formData.delete('phone_alt');
                  try {
                    const res = await fetch(form.action, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                    });
                    const responseText = await res.text();
                    let parsed;
                    try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                    const serverMsg = parsed?.meta?.message || parsed?.message || '';
                    const msg = document.getElementById('newsletter-msg');
                    if (res.ok && parsed?.code === 'OK') {
                      if (msg) { msg.textContent = '订阅成功！感谢您的关注。'; msg.className = 'mt-3 text-sm text-green-600'; }
                      form.reset();
                    } else {
                      if (msg) { msg.textContent = serverMsg || '订阅失败，请稍后再试。'; msg.className = 'mt-3 text-sm text-red-500'; }
                    }
                  } catch {
                    const msg = document.getElementById('newsletter-msg');
                    if (msg) { msg.textContent = '网络错误，请稍后再试。'; msg.className = 'mt-3 text-sm text-red-500'; }
                  }
                }}
              >
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="输入您的邮箱地址"
                  className="flex-1 px-4 py-3 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                />
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  立即订阅
                </button>
              </form>
              <p id="newsletter-msg" className="mt-3 text-sm"></p>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}